import { IDocumentState } from "./document-state.store";
import { MutationTree } from "vuex";
import * as _ from "./document-types.store";
import { IDocumentListingViewmodel, IDocumentTypeListingViewmodel, IDocumentParamter } from "../../models/documents";
import { ActivityStatus, CrudStatus } from "../../common/enums";
import { IDocument } from "../../models/documents/document";
export const mutations: MutationTree<IDocumentState> = {
  [_.DOCUMENT_GET_DOCUMENTS_LOADING]: (state: IDocumentState, activityStatus: ActivityStatus) => {
    state.activityStatus = activityStatus;
  }
  , [_.DOCUMENT_DELETE_DOCUMENT_LOADING]: (state: IDocumentState, activityStatus: ActivityStatus) => {
    state.removeActivityStatus = activityStatus;
  }
  , [_.DOCUMENT_GET_DOCUMENTS_SIDEBAR_LOADING]: (state: IDocumentState, activityStatus: ActivityStatus) => {
    state.sidebarDocumentsActivityStatus = activityStatus;
  }
  , [_.DOCUMENT_GET_DOCUMENTS_SIDEBAR]: (state: IDocumentState, documents: IDocumentListingViewmodel[]) => {
    state.sidebarDocumentsActivityStatus = ActivityStatus.Loaded;
    state.sidebarDocuments = documents;
  }
  , [_.DOCUMENT_GET_DOCUMENTS_TYPE_LOADING]: (state: IDocumentState, activityStatus: ActivityStatus) => {
    state.sidebarDocumentTypeActivityStatus = activityStatus;
  }
  , [_.DOCUMENT_SET_DOCUMENTS]: (state: IDocumentState, documents: IDocumentListingViewmodel[]) => {
    state.documents = documents;
    state.activityStatus = ActivityStatus.Loaded;
  }
  , [_.DOCUMENT_GET_DOCUMENT_TYPES]: (state: IDocumentState, documentTypes: IDocumentTypeListingViewmodel[]) => {
    state.documentTypes = documentTypes;
    state.activityStatus = ActivityStatus.Loaded;
  }
  , [_.DOCUMENT_DELETE_DOCUMENT]: (state: IDocumentState, id: string) => {
    state.removeActivityStatus = ActivityStatus.Loaded;
    state.sidebarDocuments = state.sidebarDocuments.filter(x => x.id !== Number(id));
    state.documents = state.documents.filter(x => x.id !== Number(id));
  },
  [_.DOCUMENT_SET_DOCUMENT_PARAMETER] : (state: IDocumentState, payload?: IDocumentParamter) => {
    state.documentParameter = {
      ...state.documentParameter,
      ...payload
    }
  },
  [_.DOCUMENT_SET_DOCUMENTS_PAGINATION]: (state: IDocumentState, payload: { page?: number, total_pages?: number, total?:number }) => {
    if(payload.total_pages){
      payload.total_pages= payload.total_pages / 10
      if(Math.floor(payload.total_pages) !== payload.total_pages ) payload.total_pages = Math.floor(payload.total_pages) + 1
    }

    state.pagination= {
      ...state.pagination,
      ...payload
    }
  }
  , [_.DOCUMENT_SET_DOCUMENT_ACTION]: (state: IDocumentState, status: CrudStatus) => {
     state.crudActionStatus= status
  }
  , [_.DOCUMENT_SET_LOADER_STATE]: (state: IDocumentState, payload: { key: string, value: boolean }) => {
    state.loaders= new Map([
      ...state.loaders,
      [payload.key,payload.value]
    ])
  }
  , [_.DOCUMENT_SET_DOCUMENT] : (state: IDocumentState, payload: IDocument) => {
     state.document= {
       ...state.document,
       ...payload
     }
  },
  [_.DOCUMENT_SET_ANNOTATION] : (state: IDocumentState, payload: {index:number, img:string, name:string}) => {
    state.document.attachments[payload.index].file = payload.img
    state.document.attachments[payload.index].name = payload.name
 }
  , [_.DOCUMENT_INIT_DOCUMENT]: (state: IDocumentState, document:IDocument) => {
     state.document= document
  }
  , [_.DOCUMENT_SET_DOCUMENT_SELECTION] : (state: IDocumentState, id: number ) =>{
    const index: number= state.documentSelection.indexOf(id)
    if( index === -1 ) state.documentSelection.push(id)
    else state.documentSelection.splice(index,1)
  }
  , [_.DOCUMENT_INIT_DOCUMENT_SELECTION]: (state: IDocumentState) => {
    state.documentSelection= []
  },
}



// WEBPACK FOOTER //
// ./src/store/document/document-mutations.store.ts